<template>
    <div class="login-join">
        <div class="title">现场抽奖</div>
        <van-form @submit="onSubmit">
            <van-field
                v-model="username"
                name="name"
                label="姓名"
                placeholder="姓名"
                :rules="[{ required: true, message: '请填写姓名' }]"
            />
            <van-field
                v-model="phone"
                name="phone"
                label="手机号码"
                placeholder="手机号码"
                :rules="[{ required: true, message: '请填写手机号码' }]"
            />
            <div style="margin: 16px;">
                <van-button round block type="info" native-type="submit">提交</van-button>
            </div>
        </van-form>
    </div>
</template>
<script>
    import {mapMutations,mapGetters} from 'vuex'
    import { Form, Field, CellGroup, Button } from 'vant';
    export default {
        name: 'login',
        computed: {
            // ...mapGetters({
            //     userInfo: "getUserInfo"
            // })
        },
        methods: {
            // ...mapMutations([
            //     'setUserInfo'
            // ]),
            onSubmit(values) {
                console.log('submit', values);
                let query = {
                    lid:this.$route.params.lid,
                    urid: this.userInfo.urid,
                    token: this.userInfo.token,
                    nickname:values.name,
                    phone: values.phone
                }
                this.$api.system.join(query).then(res=>{
                    if(res.success) {
                        this.$router.replace({name:'lowe'})
                    } else {
                        this.$dialog.alert({
                            title: '提示',
                            message: res.data.message,
                        });
                    }
                })
                            // this.$router.replace({name:'lowe'})
            },
            login: function () {
                this.$api.user.h5login({code: this.code}).then((res) => {
                    if (res.status * 1 === 200) {
                        let {urid, token} = res.data;
                        this.$api.user.userinfolist({urid, token}).then((res)=>{
                            let {data} = res;
                            data.token = token
                            data.urid = urid
                            this.userInfo = data
                            // this.$api.system.join({lid:this.$route.params.lid,avatarurl:data.avatarurl,nickname:data.nickname,urid, token})
                            // this.$router.replace({name:'lowe'})
                        })


                    } else {
                        this.$router.push({
                                        query:{}
                                    })
                        this.$wechat.jsAuthorize()
                    }
                })
                    
            }
        },

        data() {
            return {
                code: "",
                username: '',
                phone: '',
                userInfo: {}
            }
        },
        mounted() {
            this.$toast.loading()
            if (this.cf.isWeChat()) {
                
                let {code, state} = this.$route.query
                if (code && state === "authorize_wechat") {

                    this.code = code;
                    this.login();
                    return;
                }

                this.$wechat.jsAuthorize()

            } else {
                this.$toast.fail("请在微信中打开当前页面")
                // this.$router.push({name:'index'})
            }

        }
    }
</script>
<style lang="less" scoped>
    .login-join{
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .title{
            font-size: .48rem;
            color: #333333;
            padding: 2rem 0;
        }
    }
</style>
